import { useTranslation } from "react-i18next";
import { FaQq,FaGithub, FaSlack, FaTelegramPlane, FaTwitter } from "react-icons/fa";

function Footer() {
  const { t } = useTranslation()
  return (
    <footer className="w-full max-w-7xl py-5 px-4 sm:px-6 lg:px-8 mx-auto mb-14">
      <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-5 text-center">
        
        <div className="md:text-end space-x-2">
          <a
            className="size-8 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-full border border-transparent text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
            href="https://t.me/W3SWAP">
            <FaTelegramPlane className={'flex-shrink-0 size-3.5'}/>
          </a>
          <a
            className="size-8 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-full border border-transparent text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
            href="https://x.com/W3swap_?s=09">
            <FaTwitter className={'flex-shrink-0 size-3.5'}/>
          </a>
          <a
            className="size-8 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-full border border-transparent text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
            href="https://qm.qq.com/q/xz4MS3DkMo">
            <FaQq className={'flex-shrink-0 size-3.5'}/>
          </a>
          <a
            className="size-8 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-full border border-transparent text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
            href="/#/">
            <FaSlack className={'flex-shrink-0 size-3.5'}/>
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer